export enum InvoiceDeliveryMethod {
    EMAIL = 'EMAIL',
    EAN = 'EAN',
}

export enum BillingRecipientType {
    PRIVATE = 'PRIVATE',
    BUSINESS = 'BUSINESS',
}
